export default __webpack_public_path__ + "static/media/ThrivingInGradSchoolWeb.674941ab.jpg";